import { create as createStore } from "zustand"

type State = {
  errorMessage: string | null
}

const defaultState: State = {
  errorMessage: null,
}

const store = createStore(() => defaultState)

export function setGlobalErrorMessage(errorMessage: string | null) {
  store.setState({ errorMessage })
}

export function useGlobalErrorMessage() {
  return store((state) => state.errorMessage)
}
